import { useResources } from "../../hooks/useResources";

interface StatusCardProps {
  title: string;
  count: number;
  color: "green" | "orange" | "blue" | "red";
  type: "succeeded" | "pending" | "published" | "failed";
  onPreview?: () => void;
  onDownload?: () => void;
  onDownloadLog?: () => void;
  onDownloadZip?: () => void;
}

const StatusCard = ({
  title,
  count,
  color,
  type,
  onPreview,
  onDownload,
  onDownloadLog,
  onDownloadZip,
}: StatusCardProps) => {
  const { getResourceValue } = useResources();

  return (
    <div className={`job-details__card job-details__card--${color}`}>
      <div className="job-details__card-content">
        <div className="job-details__card-count">{count}</div>
        <div className="job-details__card-title">{title}</div>
      </div>
      <div className="job-details__card-actions">
        {type === "failed" ? (
          <>
            <button
              className="job-details__card-btn job-details__card-btn-white"
              onClick={count === 0 ? undefined : onDownloadLog}
              disabled={count === 0}
            >
              <i className="f-icon download-icon"></i>
              {getResourceValue("download_log", "Download Log")}
            </button>
            <button
              className="job-details__card-btn job-details__card-btn--green"
              onClick={count === 0 ? undefined : onDownloadZip}
              disabled={count === 0}
            >
              <i className="f-icon download-icon"></i>
              {getResourceValue("download", "Download")}
            </button>
          </>
        ) : (
          <>
            <button
              className="job-details__card-btn job-details__card-btn-white"
              onClick={count === 0 ? undefined : onPreview}
              disabled={count === 0}
            >
              <i className="f-icon eye-icon"></i>
              {getResourceValue("preview", "Preview")}
            </button>
            <button
              className="job-details__card-btn job-details__card-btn--green"
              onClick={count === 0 ? undefined : onDownload}
              disabled={count === 0}
            >
              <i className="f-icon download-icon"></i>
              {getResourceValue("download", "Download")}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default StatusCard;


